const doTheScroll = () => {
	if (document.URL.indexOf('faqs-notices-policies') > 0 && document.URL.indexOf('#q=') > 1) {
 		var headerOffset = 0;
	    Modernizr.mq('(min-width: 768px)') ? headerOffset = 115 : headerOffset = 0;
		var scrollToParam = document.URL.split('#q=')[1];
	        scrollToParam = scrollToParam.split("&")[0];
	    var selectedQuestion = $('#' + scrollToParam);
	    if (selectedQuestion.length > 0) {
	        var checkExist = setInterval(function() {
	            $('html, body').animate({
	                scrollTop: selectedQuestion.offset().top - headerOffset
	            }, 700);
	            clearInterval(checkExist);
	        }, 500);
	    }
	    return false;
	}
};

export const selectScroller = () => {
    doTheScroll();
   	$(window).on('hashchange',function(){
   	   	$("#footer").each(function(){
   	   		$(this).find('div div section ul li a').each(function () {
   	   			var currentPage = $(location).attr('href'),
   			        scrollto = $(this).attr('href'),
   					newHash = location.hash.slice(1);
   		   		if(currentPage.indexOf('#q=') > 1){
   	 	   	   		if(scrollto != 'undefined' && scrollto != null && newHash != 'undefined'){
   		   	   			if (scrollto.indexOf(newHash) >= 0){
   	 	   	   				$(this).attr('onclick', 'javascript:location.reload();');
   		   	   				$(this).click();
   		   	   			};
   		   	   		};
   		   		};
   	   		});
   	   	});
   		$("#mobile-footer").each(function(){
	   		$(this).find('div div div ul li a').each(function () {
	   			var currentPage = $(location).attr('href'),
	 		        scrollto = $(this).attr('href'),
	   				newHash = location.hash.slice(1);
     	   		if(currentPage.indexOf('#q=') > 1){
         	   	   	if(scrollto != 'undefined' && scrollto != null && newHash != 'undefined'){
	    	   	   		if (scrollto.indexOf(newHash) >= 0){
	    	   	   			$(this).attr('onclick', 'javascript:location.reload();');
	    	   	   			$(this).click();
	   	    			};
	    	   	   	};
    	   		};
	   		});
	  	});
	  	return false;
   	});

   	 //Policies and Notices
    $('#policies-notices-select').on('change', function() {
    	var headerOffset = 0;
	    Modernizr.mq('(min-width: 768px)') ? headerOffset = 115 : headerOffset = 0;
        var selectedValue = this.value,
            selectedQuestion = "#policies-notices-question-" + selectedValue;

        // hack for not having all questions and content in the static page
        // this if statement will need to be removed / reworked
        if (selectedValue == "0" || selectedValue == "undefinded") {
            $('html, body').animate({
                scrollTop: 0
            }, 500);
        } else {
            $('html, body').animate({
                scrollTop: $(selectedQuestion).offset().top - headerOffset
            }, 500);
        }

        return false;
    });
   	  
    //FAQ
    $('#faq-questions-select').on('change', function() {
    	var headerOffset = 0;
	    Modernizr.mq('(min-width: 768px)') ? headerOffset = 115 : headerOffset = 0;
        var selectedValue = this.value,
            selectedQuestion = "#faq-question-" + selectedValue;

        // hack for not having all questions and content in the static page
        // this if statement will need to be removed / reworked

        if (selectedValue == "0" || selectedValue == "undefinded") {
            $('html, body').animate({
                scrollTop: 0
            }, 500);
        } else {
            $('html, body').animate({
                scrollTop: $(selectedQuestion).offset().top - headerOffset
            }, 500);
        }

        return false;
    });

    //fix to change hrefs to reloads when url contains href
   	$("#footer").each(function(){
   		$(this).find('div div section ul li a').each(function () {
   			var currentPage = $(location).attr('href'),
 		        scrollto = $(this).attr('href');
   			if(scrollto != 'undefined' && scrollto != null && currentPage != 'undefined'){
	   			if (currentPage.indexOf("#") > 0 || scrollto.indexOf("#") > 0 ){
		   			if (currentPage.indexOf(scrollto) >= 0){
		   				$(this).attr('onclick', 'javascript:location.reload();');
		    	 	};
	   			};
   			};
   		});
   	});
   	$("#mobile-footer").each(function(){
   		$(this).find('div div div ul li a').each(function () {
   			var currentPage = $(location).attr('href'),
 		        scrollto = $(this).attr('href');
   			if(scrollto != 'undefined' && scrollto != null && currentPage != 'undefined'){
	   			if (currentPage.indexOf("#") > 0 || scrollto.indexOf("#") > 0 ){
		   			if (currentPage.indexOf(scrollto) >= 0){
		   				$(this).attr('onclick', 'javascript:location.reload();');
		    	 	};
	   			};
   			};
   		});
   	});
 };
